import { loadingBarReducer as loadingBar } from 'react-redux-loading-bar';

import locale from './locale';
import authentication from './authentication';
import applicationProfile from './application-profile';

import administration from 'app/modules/administration/administration.reducer';
import userManagement from 'app/modules/administration/user-management/user-management.reducer';
import register from 'app/modules/account/register/register.reducer';
import activate from 'app/modules/account/activate/activate.reducer';
import password from 'app/modules/account/password/password.reducer';
import settings from 'app/modules/account/settings/settings.reducer';
import passwordReset from 'app/modules/account/password-reset/password-reset.reducer';

import ecole from 'app/entities/ecole/ecole.reducer';
// prettier-ignore
import classe from 'app/entities/classe/classe.reducer';
// prettier-ignore
import eleve from 'app/entities/eleve/eleve.reducer';
// prettier-ignore
import parent from 'app/entities/parent/parent.reducer';
// prettier-ignore
import surveillant from 'app/entities/surveillant/surveillant.reducer';
// prettier-ignore
import directeur from 'app/entities/directeur/directeur.reducer';
// prettier-ignore
import professeur from 'app/entities/personnel/personnel.reducer';
// prettier-ignore
import support from 'app/entities/support/support.reducer';

import notification from 'app/entities/notification/notification.reducer';

import destinataire from 'app/entities/notification/destinataire.reducer';
import appConfig from 'app/entities/appConfig/appConfig.reducer';
import matiereEcole from 'app/entities/matiere-ecole/matiere-ecole.reducer';
import cycle from 'app/entities/cycle/cycle.reducer';
import periodeEvaluation from 'app/entities/periode-evaluation/periode-evaluation.reducer';
import evaluation from 'app/entities/evaluation/evaluation.reducer';
import calendarEntry from 'app/entities/calendar/calendarEntry.reducer';
import cours from 'app/entities/cours/cours-reducer';
import comptable from 'app/entities/comptable/comptable-reducer';
import absences from 'app/entities/cours/absence-reducer';
import scolarite from 'app/entities/scolarite/scolarite.reducer';
import facture from 'app/entities/factures/facture.reducer';
import finance from 'app/entities/finances/finance.reducers';
import virement from 'app/entities/virement/virement.reducer';
import approvisonnement from 'app/entities/approvisonnements/appro.reducer';
import payment from 'app/entities/payments/payment.reducer';
import salaire from 'app/entities/salaire/salaire.reducer';
import ecoleConfig from 'app/entities/ecoleConfig/ecoleConfig.reducer';
import anneeScolaire from 'app/entities/annee-scolaire/annee-scolaire.reducer';
import uploads from 'app/entities/uploads/uploads.reducer';
import transaction from 'app/entities/transaction/transaction.reducer';
import note from 'app/entities/notes/note.reducer';
import sousMatiere from 'app/entities/sous-matiere/sous-matiere.reducer';
import dispenseCours from 'app/entities/eleve/dispense-cours.reducer';
import bulletinBranding from 'app/entities/bulletin-branding/bulletin-branding.reducer';

/* jhipster-needle-add-reducer-import - JHipster will add reducer here */

const rootReducer = {
  authentication,
  locale,
  applicationProfile,
  administration,
  userManagement,
  register,
  activate,
  passwordReset,
  password,
  settings,
  ecole,
  classe,
  eleve,
  parent,
  surveillant,
  directeur,
  professeur,
  absences,
  cours,
  support,
  appConfig,
  notification,
  destinataire,
  calendarEntry,
  comptable,
  scolarite,
  facture,
  finance,
  matiereEcole,
  cycle,
  periodeEvaluation,
  evaluation,
  virement,
  approvisonnement,
  payment,
  salaire,
  ecoleConfig,
  anneeScolaire,
  uploads,
  transaction,
  note,
  sousMatiere,
  dispenseCours,
  bulletinBranding,
  /* jhipster-needle-add-reducer-combine - JHipster will add reducer here */
  loadingBar,
};

export default rootReducer;
